'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LocationIcon = require('./LocationIcon');

var _LocationIcon2 = _interopRequireDefault(_LocationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LocationIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/LocationIcon/index.js
// module id = 293
// module chunks = 0